import { createTRPCContext } from '@trpc/tanstack-react-query';
import { inferRouterOutputs } from '@trpc/server';
import type { RentalsPaymentsPortalRouter } from '@src/backend/src/rentals/functions/paymentsPortal';

export const { TRPCProvider, useTRPC } = createTRPCContext<RentalsPaymentsPortalRouter>();

export type RentalsPaymentsPortalRouterOutputs = inferRouterOutputs<RentalsPaymentsPortalRouter>;
